<template>
  <div class="mainFooter">
    <div class="top">
      <div class="logo" :title="$t('seo.logo')">
        <img src="@/assets/images/logo.png" alt="logo">
        <img src="@/assets/images/logo-text.png" alt="logo">
      </div>
      <div class="funcs">
        <router-link to="/">{{ $t('header.text1') }}</router-link>
        <router-link to="/about">{{ $t('header.text2') }}</router-link>
        <router-link to="/games">{{ $t('header.text3') }}</router-link>
      </div>
      <div class="socialMedia"></div>
    </div>
    <div class="copyRight">
      <span>Copyright &copy; 2024 Website. All rights reserved.</span>
    </div>
  </div>
</template>

<script>
// import { gameList } from '@/axios/userInfo';

export default {
  name: 'FooterComp',
  components: {},
  data() {
    return {
      result: {}
    }
  },
  created() {
  },
  methods: {
    // async getList() {
    //   try {
    //     const params = {
    //       clientId: 'JksxUbWNDwyvLY0',
    //       clientKey: 'DDd5gEJKa4Vg9rhEsy509zYL'
    //     }
    //     await gameList(params)
    //   } catch (err) {
    //     console.log('err:: ', err);
    //   }
    // }
  }
}
</script>

<style lang="scss" scoped>@use "@/assets/scss/footer.scss";</style>
